import { Quote } from "lucide-react";

const partners = [
  {
    name: "Juan Carlos Artus",
    role: "El Experto Inmobiliario",
    bio: "Con más de 20 años en el mercado chileno, Juan Carlos ha liderado oficinas de corretaje de alto rendimiento. Su visión aporta el conocimiento real de los dolores y necesidades diarias del corredor independiente.",
    image: "/Juan Carlos.png"
  },
  {
    name: "Vicente Gutiérrez",
    role: "El Visionario Tecnológico",
    bio: "Ingeniero de Software especializado en IA y Big Data. Vicente es la mente detrás de nuestro algoritmo de valorización y la arquitectura CRM, enfocada en automatizar lo complejo para simplificar el negocio.",
    image: "/Guti.png"
  },
  {
    name: "Nicolas Fernandez",
    role: "El Estratega Comercial",
    bio: "Experto en desarrollo de negocios y estrategias de mercado. Nicolas garantiza que cada proceso dentro de la plataforma esté alineado con las oportunidades comerciales y el crecimiento de nuestros asociados.",
    image: "/Nico Fernandez.png"
  }
];

export function AboutUs() {
  return (
    <section className="py-24 bg-parchment overflow-hidden">
      <div className="container mx-auto px-4">
        {/* Narrativa Central */}
        <div className="max-w-5xl mx-auto mb-32">
          <div className="brutalist-border bg-ink text-parchment p-12 relative">
            <Quote className="absolute -top-8 -left-8 h-24 w-24 text-terracotta opacity-20 rotate-12" />
            <p className="text-3xl md:text-5xl font-display font-black uppercase italic leading-tight text-center">
              "No solo queríamos crear otra página de propiedades. Queríamos crear la herramienta que nosotros mismos desearíamos haber tenido al empezar."
            </p>
          </div>
        </div>

        {/* Perfiles de Socios */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-1">
          {partners.map((partner, i) => (
            <div key={i} className="brutalist-border bg-parchment group hover:bg-ink hover:text-parchment transition-all duration-500">
              <div className="relative h-[400px] overflow-hidden">
                <img 
                  src={partner.image} 
                  alt={partner.name} 
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000 scale-110 group-hover:scale-100" 
                />
                <div className="absolute inset-0 bg-ink/20 group-hover:bg-transparent transition-colors" />
              </div>
              <div className="p-8">
                <span className="text-[10px] font-black uppercase tracking-widest text-terracotta mb-4 block">Fundador</span>
                <h3 className="text-3xl font-display font-black uppercase italic mb-2">{partner.name}</h3>
                <p className="text-xs font-black uppercase tracking-widest opacity-40 mb-6">{partner.role}</p>
                <p className="font-serif italic text-lg leading-relaxed opacity-70 group-hover:opacity-100">
                  {partner.bio}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Misión Conjunta */}
        <div className="mt-32 border-t-2 border-ink pt-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
            <div>
              <h2 className="text-5xl md:text-7xl font-display font-black uppercase italic mb-8">Unión de <br /> Fuerzas</h2>
              <p className="text-xl font-serif italic text-ink/60 mb-12 leading-relaxed">
                La experiencia de campo de Juan Carlos, el motor tecnológico de Vicente y la visión estratégica de Nicolas se fusionan en una sola plataforma diseñada para que tú, el corredor independiente, seas el protagonista del mercado.
              </p>
              <div className="space-y-6">
                <div className="flex items-center gap-6">
                  <div className="w-4 h-4 bg-terracotta rotate-45" />
                  <span className="text-xs font-black uppercase tracking-[0.3em]">Propósito Claro</span>
                </div>
                <div className="flex items-center gap-6">
                  <div className="w-4 h-4 bg-moss rotate-45" />
                  <span className="text-xs font-black uppercase tracking-[0.3em]">Tecnología Ética</span>
                </div>
                <div className="flex items-center gap-6">
                  <div className="w-4 h-4 bg-ink rotate-45" />
                  <span className="text-xs font-black uppercase tracking-[0.3em]">Seguridad Jurídica</span>
                </div>
              </div>
            </div>
            <div className="brutalist-border bg-ink p-2">
              <div className="p-12 border-2 border-parchment/20 space-y-8">
                <h4 className="text-2xl font-display font-black uppercase italic text-parchment">Nuestra Misión</h4>
                <p className="font-serif italic text-parchment/60 text-lg">
                  Empoderar a miles de corredores independientes en toda Latinoamérica, entregándoles las herramientas de nivel corporativo que necesitan para competir y ganar en la nueva era digital del Real Estate.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
